import { $_app_server } from '@/_helpers'

export const memberService = {
  create,
  update,
  updatePersona,
  deleteFromSession,
  statuses,
  personaAlerts,
  personaAlertsLetter, 
  genCode
}

function create( courtCase_id, member ) {
    return $_app_server.post("cases/" + courtCase_id + "/members", member).then(response => response.data)
}

function update( member ) {
    return $_app_server.put("members", member).then(response => response.data)
}

function updatePersona( persona ) {
    return $_app_server.put("persons/", persona).then(response => response.data)
}

function deleteFromSession(id) {
    return $_app_server.delete("members/" + id)
}

function statuses() {
    return $_app_server.get("memberstatuses").then(response => response.data)
}

function personaAlerts(obj) {
    return $_app_server.post("personaalerts", obj)
}

function personaAlertsLetter(letterId, obj) {
    return $_app_server.post("personaalerts/letter/" + letterId, obj).then(response => response.data)
}

function genCode (memberId) {
  return $_app_server.get("/member/gencode/" + memberId)
  .then(response => response.data)
}
